var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopShortLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19,
  viewBox: "0 0 20 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.87 6.868c.478 0 .93.21 1.229.57l.556.67c.411.495.46 1.184.12 1.728l-.956 1.536.544 1.31c.305.737.19 1.575-.304 2.21l-.705.907v1.685c0 .837-.704 1.516-1.573 1.516H6.817c-.869 0-1.573-.679-1.573-1.516V7.497c0-.633.205-1.249.586-1.763L9.96.159a.4.4 0 0 1 .476-.128l.056.023C11.935.65 12.7 2.18 12.288 3.64l-.913 3.228zM1.573 7.878C.704 7.877 0 8.555 0 9.393v8.088c0 .837.704 1.516 1.573 1.516h2.098V7.878z"
})));
export default SvgYoutubeDesktopShortLike;